<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>{{
                    $t("integrations.google.modal.title")
                }}</DialogTitle>
            </DialogHeader>

            <div class="my-2">
                <GoogleIntegration
                    :integration="integration"
                ></GoogleIntegration>
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import GoogleIntegration from "./GoogleIntegration.vue";

defineProps<{
    integration?: any;
}>();
const opened = ref(false);

const closeModal = () => {
    opened.value = false;
};
</script>

<style></style>
